var notification = require('notification'),
    formValidation = require('formValidation'),
    loader = require('loader'),
    authenticationService = require('authenticationService'),
    getUrlParameter = require('getUrlParameter'),
    newPasswordRequirments = require('newPasswordRequirments');

var userCeateNewPassword = (function () {
    var formValidation = function () {
        $('#create-new-password-form').validate({
            onfocusout: false,
            onkeyup: false,
            onclick: false,
            onsubmit: true,
            highlight: function (element) {
                $('.login .panel.left-panel').addClass('has-error');
            },
            rules: {
                new_password: {
                    required: true,
                    newPassword: true
                },
                repeat_password: {
                    required: true,
                    equalTo: '#new_password',
                }
            },
            submitHandler: function () {
                $('.login .panel.left-panel').removeClass('has-error').addClass('passed');
                $('window').showLoader();
                checkUserDetails();
            },
        });
    };
    var checkUserDetails = function () {
        var item = new Object();
        item.password = $('#new_password').val();
        item.confirmPassword = $('#repeat_password').val();
        item.a = $('window').getUrlParameter('a');
        item.b = $('window').getUrlParameter('b');
        var data = JSON.stringify(item);
        createNewPasswordService(data, createNewPasswordResponse, createNewPasswordErrorResponse);
    };

    var createNewPasswordResponse = function (response) {
        if (response.statusCode === 200) {
            $('.left-panel').removeClass('has-error');
            $('window').notification({
                title: response.message,
                important: true
            });
            setTimeout(function () {
                window.location.href = "/login";
            }, 3000);

        } else {
            $('.left-panel').addClass('has-error');
            $('window').notification({
                title: response.message,
                error: true
            });
        }
    };

    var createNewPasswordErrorResponse = function () {
        $('.login .panel.left-panel').removeClass('passed').addClass('has-error');
        $('window').notification({
            title: 'Unable to communicate with the server at this time. Please try again or <a href="mailto:help@thecoachingmanual.com?subject=Cannot login">contact us if the problem persists</a>.',
            error: true
        });

    };

    var init = function () {
        formValidation();
        $('window').newPasswordRequirments($('#create-new-password-form'));
    };

    return {
        init: init
    };
})();

if ($('#create-new-password-form').length) {
    userCeateNewPassword.init();
}



// WEBPACK FOOTER //
// ./library/js/modules/login/create-new-password.js